import { render, staticRenderFns } from "./divide-sell.vue?vue&type=template&id=04493c32&scoped=true"
import script from "./divide-sell.vue?vue&type=script&lang=js"
export * from "./divide-sell.vue?vue&type=script&lang=js"
import style0 from "./divide-sell.vue?vue&type=style&index=0&id=04493c32&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04493c32",
  null
  
)

export default component.exports